import React, { FC, useState, useCallback } from "react";
import classnames from "classnames";
import {
  Filters,
  Select,
  DateInput,
  useDevice,
  CollapseSelfControlled,
  Button,
} from "@epcnetwork/core-ui-kit";

import { appTimezone } from "constants/user.constants";
import {
  apiTypes,
  httpMethodOptions,
  initialCollapseState,
  initialFilters,
  getQueryKeys,
} from "../external-vendors-list.constants";
import { CollapseState, CollapseStateKeys } from "../external-vendors-list.types";

import styles from "./list-filters.module.css";
import arrowDownImg from "assets/images/arrow-down.svg";

const ListFilters: FC = () => {
  const { isMobileDevice } = useDevice();
  const [isCollapseState, setIsCollapseState] = useState<CollapseState>(initialCollapseState);
  const queryKeys = getQueryKeys(isMobileDevice);
  const nonClearableKeys = ["search"].concat(queryKeys);

  const handleCollapseView = useCallback(
    (key: CollapseStateKeys) => {
      const stateCollapse: CollapseState = { ...isCollapseState };
      stateCollapse[key].isOpen = !stateCollapse[key].isOpen;
      setIsCollapseState(stateCollapse);
    },
    [isCollapseState],
  );

  const headerCollapse = (key: CollapseStateKeys) => {
    return (
      <Button
        appearance="text"
        className={styles.collapseWrapper}
        onClick={() => handleCollapseView(key)}
      >
        <div className={styles.leftPart}>
          <img
            src={arrowDownImg}
            alt=""
            className={classnames({ [styles.revertArrow]: isCollapseState[key].isOpen })}
          />
          <div className={styles.label}>{`By ${key}`}</div>
        </div>
      </Button>
    );
  };

  return (
    <Filters initialFilters={initialFilters} nonClearableKeys={nonClearableKeys}>
      {({ getDatePickerDate, setDatePickerDate, getSelect, setSelect }) => {
        const [startFrom, startTo] = getDatePickerDate("createdAt");
        const [endFrom, endTo] = getDatePickerDate("updatedAt");

        return (
          <div>
            <Filters.ContentItem>
              <CollapseSelfControlled
                triggerElement={headerCollapse("method")}
                initiallyOpened={isCollapseState["method"].isOpen}
                removeFromDOMOnClosed
                triggerClassName={styles.triggerElement}
              >
                <Select
                  selectedOptionsKeys={getSelect("httpMethod", true)}
                  onChange={setSelect("httpMethod", true)}
                  options={httpMethodOptions}
                  isMulti
                  placeholder="Select method"
                  disableError
                />
              </CollapseSelfControlled>
            </Filters.ContentItem>

            <Filters.ContentItem>
              <CollapseSelfControlled
                triggerElement={headerCollapse("type")}
                initiallyOpened={isCollapseState["type"].isOpen}
                removeFromDOMOnClosed
                triggerClassName={styles.triggerElement}
              >
                <Select
                  selectedOptionsKeys={getSelect("apiType", true)}
                  onChange={setSelect("apiType", true)}
                  options={apiTypes}
                  isMulti
                  disableError
                  placeholder="Select api type"
                />
              </CollapseSelfControlled>
            </Filters.ContentItem>

            <Filters.ContentItem>
              <CollapseSelfControlled
                triggerElement={headerCollapse("created")}
                initiallyOpened={isCollapseState["created"].isOpen}
                removeFromDOMOnClosed
                triggerClassName={styles.triggerElement}
              >
                <DateInput
                  dateFrom={startFrom}
                  dateTo={startTo}
                  onChange={setDatePickerDate("createdAt", true)}
                  isMulti
                  disableError
                  timezone={appTimezone}
                  className={styles.inputDate}
                />
              </CollapseSelfControlled>
            </Filters.ContentItem>

            <Filters.ContentItem>
              <CollapseSelfControlled
                triggerElement={headerCollapse("updated")}
                initiallyOpened={isCollapseState["updated"].isOpen}
                removeFromDOMOnClosed
                triggerClassName={styles.triggerElement}
              >
                <DateInput
                  dateFrom={endFrom}
                  dateTo={endTo}
                  onChange={setDatePickerDate("updatedAt", true)}
                  isMulti
                  disableError
                  timezone={appTimezone}
                  className={styles.inputDate}
                />
              </CollapseSelfControlled>
            </Filters.ContentItem>
          </div>
        );
      }}
    </Filters>
  );
};

export default ListFilters;
